import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';

const BioStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 2rem;
  margin-bottom: 50px;

  .description {
    max-width: 65ch;
  }

  @media screen and (max-width: 769px) {
    grid-template-columns: 1fr 3fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const HomePageLinksStyles = styled.div`
  a {
    font-weight: bold;
    color: var(--black);
    text-decoration: none;
    transition: all 0.1s ease;
  }

  a:hover {
    color: var(--pop);
  }

  a + a {
    margin-left: 50px;
  }

  @media screen and (max-width: 769px) {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const IndexPage = ({ data }) => {
  const homePageInfo = data.allSanityHomePageSettings.nodes[0];

  return (
    <>
      <Header />
      <main>
        <title>Home Page</title>
        <h1 id="main-name">{homePageInfo.name}</h1>
        <p id="title">{homePageInfo.title}</p>
        <BioStyles>
          <GatsbyImage
            image={homePageInfo.mug.asset.gatsbyImageData}
            alt={homePageInfo.name}
          />
          <div className="description">
            {homePageInfo.description.map((item, i) => {
              return <p key={i}>{item.children[0].text}</p>;
            })}
          </div>
        </BioStyles>
        <hr />
        <HomePageLinksStyles>
          {homePageInfo.linkList.map((link, i) => {
            return (
              <a href={link.url} key={i}>
                {link.site}
              </a>
            );
          })}
        </HomePageLinksStyles>
      </main>
      <Footer />
    </>
  );
};

export default IndexPage;

export const query = graphql`
  {
    allSanityHomePageSettings {
      nodes {
        description {
          children {
            text
          }
        }
        mug {
          asset {
            gatsbyImageData
          }
        }
        name
        title
        linkList {
          site
          url
        }
      }
    }
  }
`;
